var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateCloudFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 161,
    viewBox: "0 0 220 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80.5,
    r: 80,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 20.5,
    r: 8,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 126.5,
    r: 6,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 138.5,
    r: 10,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46.5,
    r: 10,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 11.5,
    r: 7,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3256_17502)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.486 16.5C96.7495 16.5 81.9448 24.7701 72.9354 37.4466C69.9934 36.7528 66.9253 36.3857 63.7714 36.3857C41.8063 36.3857 24 54.192 24 76.1571C24 98.1223 41.8063 115.929 63.7714 115.929H163.2C182.42 115.929 198 100.348 198 81.1286C198 61.9091 182.42 46.3286 163.2 46.3286C161.835 46.3286 160.488 46.4072 159.164 46.5601C151.546 28.8784 133.961 16.5 113.486 16.5Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.7714,
    cy: 76.1562,
    r: 39.7714,
    fill: "url(#paint0_linear_3256_17502)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.486,
    cy: 66.2143,
    r: 49.7143,
    fill: "url(#paint1_linear_3256_17502)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.2,
    cy: 81.1281,
    r: 34.8,
    fill: "url(#paint2_linear_3256_17502)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 84.5,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#C2ECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.333 101.148V105.967C112.333 106.621 112.333 106.947 112.46 107.197C112.572 107.416 112.751 107.595 112.97 107.707C113.22 107.834 113.546 107.834 114.2 107.834H119.019M119.333 110.154V118.567C119.333 120.528 119.333 121.508 118.952 122.256C118.616 122.915 118.081 123.45 117.422 123.786C116.673 124.167 115.693 124.167 113.733 124.167H106.267C104.306 124.167 103.326 124.167 102.578 123.786C101.919 123.45 101.384 122.915 101.048 122.256C100.667 121.508 100.667 120.528 100.667 118.567V106.434C100.667 104.474 100.667 103.494 101.048 102.745C101.384 102.086 101.919 101.551 102.578 101.215C103.326 100.834 104.306 100.834 106.267 100.834H110.014C110.87 100.834 111.298 100.834 111.7 100.931C112.058 101.016 112.399 101.158 112.712 101.35C113.065 101.566 113.368 101.869 113.973 102.474L117.693 106.194C118.298 106.799 118.601 107.102 118.817 107.455C119.009 107.768 119.151 108.11 119.236 108.467C119.333 108.869 119.333 109.298 119.333 110.154Z",
    stroke: "#008C99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3256_17502",
    x: 4,
    y: 16.5,
    width: 214,
    height: 139.428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3256_17502"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3256_17502"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3256_17502"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3256_17502",
    result: "effect2_dropShadow_3256_17502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3256_17502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3256_17502",
    x1: 33.2326,
    y1: 49.8786,
    x2: 103.543,
    y2: 115.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3256_17502",
    x1: 75.3123,
    y1: 33.3673,
    x2: 163.2,
    y2: 115.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3256_17502",
    x1: 136.478,
    y1: 58.1353,
    x2: 198,
    y2: 115.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateCloudFiles);
export default __webpack_public_path__ + "static/media/empty_state_cloud_files.9171638bd2f73b8ef29ac4a4dfc2f11c.svg";
export { ForwardRef as ReactComponent };